import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Server-priced totals for the current cart (`POST /orders/quote`) —
 * subtotal, coupon discount, coins, shipping and total computed by the
 * same code `/orders/checkout` charges with. Cart and Checkout display
 * these instead of re-deriving shipping / free-shipping rules client-side.
 *
 * Returns null while a quote for the CURRENT inputs is loading (or the
 * cart is empty), so callers never show numbers for a stale cart.
 */
export default function useCheckoutQuote(items, couponCode, coinsRedeemed = 0) {
  const [state, setState] = useState({ key: null, quote: null });
  // Everything the server prices on: lines (variant + qty), coupon, coins.
  const key = JSON.stringify([
    (items || []).map((i) => [i.product_id, i.size || "", i.color || "", i.qty]),
    couponCode || "",
    coinsRedeemed || 0,
  ]);
  const hasItems = (items || []).length > 0;

  useEffect(() => {
    if (!hasItems) return undefined;
    let alive = true;
    api.post("/orders/quote", { coupon_code: couponCode || null, coins_redeemed: coinsRedeemed || 0 })
      .then(({ data }) => { if (alive) setState({ key, quote: data }); })
      .catch(() => { if (alive) setState({ key, quote: null }); });
    return () => { alive = false; };
  // `key` captures items / couponCode / coinsRedeemed.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, hasItems]);

  return hasItems && state.key === key ? state.quote : null;
}
